import { Chip, Grid, Stack, Typography } from '@mui/material';
import React from 'react';

import { useLocalStorage } from '../../hooks/useLocalStorage';
import { makeReadable } from '../../util/helpers';
import { useContractsContext } from './ContractsContext';

function ActiveContractFilters() {
  const { filters, modifyFilters, topAdvertisersActive, toggleTopAdvertisers } = useContractsContext();
  const [user] = useLocalStorage('user', null);
  const { id: userId, name: userName, is_account_manager: isAccountManager } = user;
  const filterKeys = Object.keys(filters);
  const roleFilterString = isAccountManager ? 'account_manager' : 'trafficker';
  const isFilterIncludesRoleFilter = filterKeys.includes(roleFilterString);
  const filterKeysWithoutTrafficker = filterKeys.filter((key) => key !== roleFilterString);

  const traffickerFilterChip =
    userId && userName ? (
      <Grid item>
        <Chip
          icon={
            <Stack
              sx={{
                width: '24px',
                height: '24px',
                justifyContent: 'center',
                alignItems: 'center',
                gap: '10px',
                borderRadius: '64px',
                backgroundColor: '#BDBDBD',
              }}
            >
              <Typography variant="caption">{isAccountManager ? 'AM' : 'U'}</Typography>
            </Stack>
          }
          // eslint-disable-next-line @typescript-eslint/dot-notation
          label={`${makeReadable(roleFilterString)} = ${makeReadable(filters[roleFilterString]?.name || userName)}`}
          variant="outlined"
          onDelete={isFilterIncludesRoleFilter ? () => modifyFilters(roleFilterString, null) : undefined}
          onClick={
            isFilterIncludesRoleFilter
              ? undefined
              : () =>
                  modifyFilters(roleFilterString, {
                    id: userId?.toString(),
                    name: userName,
                  })
          }
          sx={isFilterIncludesRoleFilter ? undefined : { color: 'rgba(0, 0, 0, 0.87)', opacity: 0.38 }}
        />
      </Grid>
    ) : null;

  return (
    <Grid container spacing={{ xs: 2 }} direction="row" justifyContent="flex-start" alignItems="center" my={1}>
      <Grid item>
        <Typography variant="body2">Filters:</Typography>
      </Grid>
      {traffickerFilterChip}
      {topAdvertisersActive && (
        <Grid item>
          <Chip
            label="Top 25 Advertisers"
            variant="outlined"
            onDelete={toggleTopAdvertisers}
          />
        </Grid>
      )}
      {filterKeysWithoutTrafficker.map((filterKey) => {
        const filterValue = filters[filterKey];
        if (filterKey === 'io_start_date' || filterKey === 'io_end_date') {
          return (
            <Grid item key={filterKey}>
              <Chip
                label={`${makeReadable(filterKey)} = ${filterValue.range_start}-${filterValue.range_end}`}
                color="secondary"
                onDelete={() => modifyFilters(filterKey, null)}
              />
            </Grid>
          );
        }
        return (
          <Grid item key={filterKey}>
            <Chip
              label={`${makeReadable(filterKey)} = ${
                filterKey === 'state' || filterKey === 'active_status' ? makeReadable(filterValue) : makeReadable(filterValue.name)
              }`}
              variant="outlined"
              onDelete={() => modifyFilters(filterKey, null)}
            />
          </Grid>
        );
      })}
    </Grid>
  );
}

export default ActiveContractFilters;
